module.exports = __webpack_public_path__ + "img/qiutie.bbd42cf9.png";